import { render, staticRenderFns } from "./mould_in_out_record.vue?vue&type=template&id=60b16bf3&scoped=true&"
import script from "./mould_in_out_record.vue?vue&type=script&lang=js&"
export * from "./mould_in_out_record.vue?vue&type=script&lang=js&"
import style0 from "./mould_in_out_record.vue?vue&type=style&index=0&id=60b16bf3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b16bf3",
  null
  
)

export default component.exports